export const offer = {
  creationStateLabel: "Status for new offers",
  creationStateHelp:
    "When creating new offers, a status must be specified. This can be selected here.",
  info: "If only stock or price is activated, at least one offer must be created for the item for the stock or price to be updated.",
  productAssignment: "Articleassignment",
  productAssignmentHelp:
    "In order for the product assignment to work correctly, the fields must be mapped properly (productNumber to marketplace article number, ean to GTIN)."
};
